import React, { useMemo } from 'react'
import { appName } from '../config'
import useFooterSubscriptionPackage from '../Hooks/useFooterSubscriptionPackage'

const Copyright = () => {
    const { packageName } = useFooterSubscriptionPackage()

    const displayText = useMemo(
        () => (packageName ? `${packageName} • ${appName}` : appName),
        [packageName],
    )

    return (
        <div className="copyright">
            <span>{displayText}</span>
        </div>
    )
}
export default Copyright
